export default __webpack_public_path__ + "static/media/attention.df687aa7.svg";